import React from 'react'
import { EmarModuleCard, FamilyPlanModuleCard } from '@lmc/ui-kit'
import { PaywallTemplateWrapper } from '../PaywallTemplateWrapper'
import { colors } from '@lmc/common/constants'
import { IconType } from '@lmc/ui-kit'
import { colours } from '@lmc/ui-kit/src/config/theme'

interface StateProps {
  preferredCarePlansNominative?: string
}

export const CarePlansPaywallComponent: React.FC<StateProps> = ({
  preferredCarePlansNominative,
}) => {

  return (
    <PaywallTemplateWrapper
      backgroundColor={colours.status.popout}
      title={preferredCarePlansNominative || 'Pro Plan'}
      subTitle="Provide person-centred care and empower service users to sign their own care plan. Attach risk assessments and standardise the care plan format across the service."
      bodyText="Create personalised support plans in minutes."
      icon={IconType.CarePlansHexagon}
      videoUrl="https://www.youtube.com/embed/oSATUs33VR0"
      articles={[
        {
          title: 'How do I review a care plan?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/articles/4741330-how-do-i-review-a-care-plan',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white,
        },
        {
          title: 'How do I sign a care plan?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/articles/5685192-how-do-i-sign-a-care-plan',
          iconBackgroundColour: colors.green,
          iconColour: colors.white,
        },
        {
          title: 'What other features do I get with Pro?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white,
        },
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={<FamilyPlanModuleCard />}
      findOutMoreURL="https://logmycare.co.uk/features/care-delivery"
      customLinkText="Read more"
    />
  )
}

export const CarePlansPaywall = CarePlansPaywallComponent
